import React from 'react';

const LoadingInline = ({message, progress, type}) => {
    // Round progress to two decimal places, default to 0 if undefined
    const progressValue = progress !== undefined ? parseFloat(progress.toFixed(2)) : 0;

    return (
        <div className="loading-inline-container">
            <div className="loading-inline-content">
                <span className="loading-message">{message}...</span>
                
                {type === 'progress' && (
                    <div className="progress-bar-container">
                        <div className="progress-bar">
                            <div className="progress" style={{width: `${progressValue}%`}}></div>                    
                        </div>
                        <span className="progress-value">{progressValue}%</span>
                    </div>
                )}
                
                {type === 'spinner' && (
                    <div className="loader"></div>
                )}
            </div>
        </div>
    );
}

export default LoadingInline;
